import { useFormContext } from 'react-hook-form';
import { Provider, useAtomValue } from 'jotai';
import { isCodeSentAtom } from '@/pages/verification-phone/atoms';
import { PhoneNumberInput } from '@/pages/verification-phone/components/PhoneNumberInput';
import { PhoneVerificationCodeInput } from '@/pages/verification-phone/components/PhoneVerificationCodeInput';
import { useCooldownTimer } from '@/pages/verification-phone/hooks';
import { type ProfileEditFormData } from '../schema';
export const PhoneVerificationForm = () => {
  return <Provider data-sentry-element="Provider" data-sentry-component="PhoneVerificationForm" data-sentry-source-file="PhoneVerificationForm.tsx">
      <PhoneVerificationFormContent data-sentry-element="PhoneVerificationFormContent" data-sentry-source-file="PhoneVerificationForm.tsx" />
    </Provider>;
};
const PhoneVerificationFormContent = () => {
  const {
    watch
  } = useFormContext<ProfileEditFormData>();
  const verifiedPhoneNumber = watch('verifiedPhoneNumber');
  const isCodeSent = useAtomValue(isCodeSentAtom);
  const {
    cooldownSeconds,
    isCooldownActive,
    startCooldown
  } = useCooldownTimer();
  return <div className="flex flex-col gap-xs" data-sentry-component="PhoneVerificationFormContent" data-sentry-source-file="PhoneVerificationForm.tsx">
      <PhoneNumberInput verifiedPhoneNumber={verifiedPhoneNumber} onSendSuccess={startCooldown} data-sentry-element="PhoneNumberInput" data-sentry-source-file="PhoneVerificationForm.tsx" />
      {isCodeSent && <PhoneVerificationCodeInput cooldownSeconds={cooldownSeconds} isCooldownActive={isCooldownActive} onResendSuccess={startCooldown} />}
    </div>;
};